import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useT } from "@/i18n";
import { Coins, Warning } from "@phosphor-icons/react";

const IS_OFFLINE = typeof window !== "undefined" && window.__KIHAP_OFFLINE__;

export default function OfflineTokenGuard() {
  const t = useT();
  const [balance, setBalance] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!IS_OFFLINE) return;
    let active = true;
    const load = async () => {
      try {
        const { data } = await api.get("/offline/status");
        if (!active || !data?.offline) return;
        setBalance(data.balance);
        if (data.balance > 0) setDismissed(false);
      } catch (e) { /* ignore */ }
    };
    load();
    const id = setInterval(load, 15000);
    return () => { active = false; clearInterval(id); };
  }, []);

  if (!IS_OFFLINE || balance === null) return null;

  if (balance === 0) {
    if (!dismissed) {
      return (
        <div className="fixed inset-0 z-[100] bg-background/95 backdrop-blur flex items-center justify-center p-6" data-testid="offline-recharge-modal">
          <div className="max-w-md w-full border border-gold/40 bg-card rounded-xl p-7 text-center space-y-4">
            <div className="mx-auto w-14 h-14 rounded-full bg-gold/15 grid place-items-center"><Coins weight="fill" size={28} className="text-gold" /></div>
            <h2 className="text-2xl font-bold">{t("offtok.emptyTitle")}</h2>
            <p className="text-sm text-muted-foreground">{t("offtok.emptyMsg")}</p>
            <button onClick={() => setDismissed(true)} className="inline-flex items-center justify-center gap-2 rounded-md bg-secondary px-4 py-2 text-sm font-semibold hover:bg-secondary/80" data-testid="offline-recharge-dismiss">{t("offtok.dismiss")}</button>
          </div>
        </div>
      );
    }
    return (
      <div className="fixed top-0 inset-x-0 z-[90] bg-hong text-white text-sm font-semibold px-4 py-2 flex items-center justify-center gap-2" data-testid="offline-suspended-banner">
        <Warning weight="fill" size={16} /> {t("offtok.suspended")}
      </div>
    );
  }

  if (balance < 10) {
    const low = balance < 5;
    return (
      <div className={`fixed top-0 inset-x-0 z-[90] text-sm font-semibold px-4 py-2 flex items-center justify-center gap-2 ${low ? "bg-hong text-white" : "bg-gold text-black"}`} data-testid="offline-low-banner">
        <Warning weight="fill" size={16} /> {(low ? t("offtok.low") : t("offtok.warn")).replace("{n}", balance)}
      </div>
    );
  }
  return null;
}
